import { Component, OnInit } from '@angular/core';
import { OAuthService } from './../services/o-auth';
import { Router } from '@angular/router';
import { ApiService } from './../services/api';

@Component({
  selector: 'app-dashboard',
  templateUrl: './full-layout.component.html'
})
export class FullLayoutComponent implements OnInit {

  public disabled = false;
  public status: { isopen: boolean } = { isopen: false };
  public club: any;
  public notCount: number;
  public daysLeft: number;
  constructor(private oAuthService: OAuthService, public router: Router, private apiService: ApiService) {

  }
  public toggled(open: boolean): void {
    // console.log('Dropdown is now: ', open);
  }

  public toggleDropdown($event: MouseEvent): void {
    $event.preventDefault();
    $event.stopPropagation();
    this.status.isopen = !this.status.isopen;
  }
  logout() {
    this.router.navigate(['/login']);

    return this.oAuthService.logout().then(() => {
      console.log("logout")
    });
  }
  ngOnInit(): void {
    this.club = this.oAuthService.getClub();
    this.apiService.object(`/users/${this.club.$key}`)
      .then(club => {
        this.club = club;
        const now = new Date();
        console.log(club['subscription'])
        if (club['subscription']) {
          if ((club['subscription'] * 1000) > now.getTime()) {
            this.daysLeft = Math.round(Math.abs(((club['subscription'] * 1000) - now.getTime()) / (24 * 60 * 60 * 1000)))

          } else {
            this.daysLeft = -1;
          }
        } else {
          if (club['trial']) {
            if ((club['trial'] * 1000) > now.getTime()) {
              this.daysLeft = Math.round(Math.abs(((club['trial'] * 1000) - now.getTime()) / (24 * 60 * 60 * 1000)))

            } else {
              this.daysLeft = -3;
            }
          } else {
            this.daysLeft = -2;
          }
        }


      })
    this.apiService.object(`/user-notifications/${this.club.$key}`)
      .then(club => {
        this.notCount = club.count;
      })
  }
  public notificationSeen() {
    this.notCount = 0;
    this.apiService.set(`/user-notifications/${this.club.$key}/count/`, 0)
      .then(() => {
        this.router.navigate(['/home/components/notifications']);
      })
      .catch(error => {
        console.error(error);

      });
  }
  public isDayLeft() {
    return this.daysLeft <= 45 && this.daysLeft >= 0
  }
}



// WEBPACK FOOTER //
// D:/Rohit's Project/Golfhubber/golfhubber_club_portal/src/app/layouts/full-layout.component.ts